export default __webpack_public_path__ + "static/media/Pot2.47027b9f.svg";